<template>
  <div class="sing-collesp">
    <el-collapse @change="collChange">
      <el-collapse-item name="1">
        <template slot="title">
          {{langPage['v4-singpage']['TXT_femmes']}}
          <i class="header-icon el-icon-minus" v-show="actives[0]"></i>
          <i class="header-icon el-icon-plus" v-show="!actives[0]"></i>
        </template>
        <div>
          <el-checkbox-group v-model="checkList" @change="checkBox()" v-for="(femmesData,index) in list.femmes" :key="index">
            <el-checkbox :label="femmesData.id_categorie">{{femmesData.libelle}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-collapse-item>

      <el-collapse-item title="反馈 Feedback" name="2">
        <template slot="title">
          {{langPage['v4-singpage']['TXT_hommes']}}
          <i class="header-icon el-icon-minus" v-show="actives[1]"></i>
          <i class="header-icon el-icon-plus" v-show="!actives[1]"></i>
        </template>
        <div>
          <el-checkbox-group v-model="checkList" @change="checkBox()" v-for="(hommesData,index) in list.hommes" :key="index">
            <el-checkbox :label="hommesData.id_categorie">{{hommesData.libelle}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-collapse-item>

      <el-collapse-item title="效率 Efficiency" name="3">
        <template slot="title">
          {{langPage['v4-singpage']['TXT_enfants']}}
          <i class="header-icon el-icon-minus" v-show="actives[2]"></i>
          <i class="header-icon el-icon-plus" v-show="!actives[2]"></i>
        </template>
        <div>
          <el-checkbox-group v-model="checkList" @change="checkBox()" v-for="(enfantsData,index) in list.enfants" :key="index">
            <el-checkbox :label="enfantsData.id_categorie">{{enfantsData.libelle}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "sing-collesp",
  props:{
    list:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      acheteurId: state => state.acheteurId
    }),
    langPage() {
      return this.$store.state['langPage']
    }
  },
  data() {
    return {
      activeNames: [],
      actives: [],
      checkList: []
    };
  },
  created() {
    console.log(this.list)
  },
  methods: {
    collChange(data) {
      let collaespState = new Array(3).fill(0);
      this.activeNames = data;
      if (this.activeNames.length > 0) {
        for (var i = 0; i < this.activeNames.length; i++) {
          let num = parseInt(this.activeNames[i]) - 1;
          for (var k = 0; k < collaespState.length; k++) {
            if (collaespState[num] != -1) {
              collaespState[num] = 1;
            }
          }
        }
      }
      this.actives = collaespState;
    },
    checkBox() {
        this.$emit('subCateogire',this.checkList)
    }
  }
};
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Sign/-collesp-singPage.less">
</style>
